import { CallScribeSpeaker, ILiveTranscriptSegment } from 'services/callScribe/types';
import { participantKey } from 'services/callScribe/participants';
import { liveTranscriptSegmentKey } from 'services/callScribe/transcriptOrder';

export interface IBubbleGroup {
  key: string;
  speaker: CallScribeSpeaker;
  participantId: number | null;
  startMs: number | null;
  committedText: string;
  partialText: string;
}

const collapseWhitespace = (s: string): string => s.replace(/\s+/g, ' ').trim();

export const buildGroups = (stream: ILiveTranscriptSegment[]): IBubbleGroup[] => {
  const groups: IBubbleGroup[] = [];
  for (const seg of stream) {
    const last = groups[groups.length - 1];
    if (!last || participantKey(last) !== participantKey(seg)) {
      groups.push({
        key: `t-${liveTranscriptSegmentKey(seg)}`,
        speaker: seg.speaker,
        participantId: seg.participantId ?? null,
        startMs: seg.startMs,
        committedText: seg.committed ? collapseWhitespace(seg.text) : '',
        partialText: seg.committed ? '' : collapseWhitespace(seg.text),
      });
      continue;
    }
    if (seg.committed) {
      last.committedText = collapseWhitespace(`${last.committedText} ${seg.text}`);
    } else {
      last.partialText = collapseWhitespace(seg.text);
    }
  }
  return groups;
};
